export default "__VITE_ASSET__lOTckqQz__"